<template>
    <div>
        <el-breadcrumb separator="/">
            <el-breadcrumb-item>
                <span class="page-title">理财系统</span>
            </el-breadcrumb-item>
            <el-breadcrumb-item>挖矿宝</el-breadcrumb-item>
            <el-breadcrumb-item>新币挖矿详情</el-breadcrumb-item>
        </el-breadcrumb>

        <el-button type="danger" @click="addPoolDialog" style="margin: 20px 0">增 加</el-button>
        <el-button type="primary" style="margin: 20px 20px" @click="backPage">返 回</el-button>

        <el-table border :header-cell-style="{background:'#FFF5F4',color:'#EC6D56'}"
                  :data="dataList" :row-key="() => Math.random()">
            <el-table-column prop="newCoinId" fixed="left" label="新币挖矿ID"></el-table-column>
            <el-table-column prop="poolCoin" label="矿池名称"></el-table-column>
            <el-table-column prop="coin" label="挖矿币种"></el-table-column>
            <el-table-column prop="minAmount" label="单笔最小存币数量"></el-table-column>
            <el-table-column prop="maxPointAmount" label="最大小数位" show-overflow-tooltip></el-table-column>
            <el-table-column prop="priority" label="优先级" show-overflow-tooltip></el-table-column>
            <el-table-column prop="unlockCycle" label="解锁周期" show-overflow-tooltip></el-table-column>
            <el-table-column prop="miningCycle" label="挖矿周期" show-overflow-tooltip></el-table-column>
            <el-table-column prop="totalMoney" label="总资产" show-overflow-tooltip></el-table-column>
            <el-table-column prop="unlockMoney" label="解锁资产" show-overflow-tooltip></el-table-column>
            <el-table-column prop="totalReward" label="总奖励" show-overflow-tooltip></el-table-column>
            <el-table-column prop="totalPeople" label="参与人数" show-overflow-tooltip></el-table-column>
            <el-table-column prop="beginTime" label="开始时间" show-overflow-tooltip>
                <template slot-scope="scope">
                    <span>{{scope.row.beginTime | moment}}</span>
                </template>
            </el-table-column>
            <el-table-column prop="stopUsing" label="转入停用" show-overflow-tooltip>
                <template slot-scope="scope">
                    <el-switch :value="scope.row.stopUsing==0?true:false" active-color="#13ce66"
                               inactive-color="#ff4949"
                               @change="alterStopUsing(scope.row.id,$event)"/>
                </template>
            </el-table-column>
            <el-table-column prop="putStatus" label="上/下架" show-overflow-tooltip>
                <template slot-scope="scope">
                    <el-switch :value="scope.row.putStatus==0?true:false" active-color="#13ce66"
                               inactive-color="#ff4949"
                               @change="alterPutStatus(scope.row.id,$event)"/>
                </template>
            </el-table-column>
            <el-table-column label="创建时间">
                <template slot-scope="scope">
                    <span>{{scope.row.createTime | moment}}</span>
                </template>
            </el-table-column>
            <el-table-column label="操作" fixed="right" width="350">
                <template slot-scope="scope">
                    <el-button type="primary" @click="unlockPool(scope.row.id)">一键解锁</el-button>
                    <el-button type="primary" @click="rewardConfigDialog(scope.row.id)">奖励配置</el-button>
                    <el-button type="primary" @click="incomeDetailDialog(scope.row.id)">收益明细</el-button>
                    <el-button type="primary" @click="assetDetailDialog(scope.row.id)" style="margin-top: 10px">资产明细
                    </el-button>
                    <el-button type="primary" @click="updatePoolDialog(scope.row)">编辑</el-button>
                    <el-button type="danger" @click="deletePool(scope.row.id)">删除</el-button>
                </template>
            </el-table-column>
        </el-table>

        <el-pagination style="margin-top: 30px"
                       @size-change="handleSizeChange"
                       @current-change="handleCurrentChange"
                       :current-page="queryParams.page"
                       :page-sizes="[10, 20, 50, 100]"
                       :page-size="queryParams.size"
                       layout="total, sizes, prev, pager, next, jumper"
                       :total="total">
        </el-pagination>

        <!--新增或修改弹框-->
        <el-dialog :title="title" :visible.sync="dialogVisible" width="800px" @close="clearData"
                   :close-on-click-modal="false">
            <el-form label-width="150px" :model="addData" :rules="addRules" ref="addForm">
                <el-form-item label="新币挖矿关联ID：" prop="newCoinId" style="padding-top: 20px">
                    <el-input v-model="addData.newCoinId" placeholder="新币挖矿关联ID" disabled
                              style="width: 500px"></el-input>
                </el-form-item>
                <el-form-item label="存入币种：" prop="poolCoin" style="padding-top: 20px">
                    <el-autocomplete class="inline-input" style="width: 500px" :disabled="edit"
                                     v-model="addData.poolCoin"
                                     :fetch-suggestions="querySearch"
                                     placeholder="请输入币种">
                        <i class="el-icon-close el-input__icon" slot="suffix"
                           @click="cleanSearchCoin" style="cursor:pointer;">
                        </i>
                    </el-autocomplete>
                </el-form-item>
                <el-form-item label="单笔最小存币数量：" prop="minAmount" style="padding-top: 20px">
                    <el-input v-model="addData.minAmount" placeholder="单笔最小存币数量(正整数：0＜X≤999999999)"
                              style="width: 500px"></el-input>
                </el-form-item>
                <el-form-item label="最大小数位：" prop="maxPointAmount" style="padding-top: 20px">
                    <el-input v-model="addData.maxPointAmount" placeholder="最大小数位(正整数：0＜X≤8)"
                              style="width: 500px"></el-input>
                </el-form-item>
                <el-form-item label="解锁周期：" prop="unlockCycle" style="padding-top: 20px">
                    <el-input v-model="addData.unlockCycle" placeholder="预期年化(正整数：0＜X≤9999)"
                              style="width: 500px"></el-input>
                </el-form-item>
                <el-form-item label="优先级：" prop="priority" style="padding-top: 20px">
                    <el-input v-model="addData.priority" placeholder="优先级(正整数：0＜X≤999999999)"
                              style="width: 500px"></el-input>
                </el-form-item>
            </el-form>

            <span slot="footer" class="dialog-footer">
                <el-button type="danger" :loading="loading" @click="poolAddOrUpdate">确 定</el-button>
            </span>
        </el-dialog>

        <RewardConfig/>
        <AssetDetail/>
        <IncomeDetail/>
    </div>
</template>

<script>
    import '../store';
    import api from '../api';
    import {mapMutations, mapState} from 'vuex';
    import RewardConfig from './rewardConfig';
    import AssetDetail from './assetDetail';
    import IncomeDetail from './incomeDetail';

    export default {
        name: 'Regular',
        components: {
            RewardConfig,
            AssetDetail,
            IncomeDetail
        },
        data() {
            return {
                dataList: [],
                total: 0,
                coinTypes: [],
                currId: "",
                queryParams: {newCoinId: "", page: 1, size: 10},
                title: "",
                dialogVisible: false,
                addData: {
                    id: "",
                    newCoinId: "",
                    poolCoin: "",
                    minAmount: "",
                    maxPointAmount: "",
                    priority: "",
                    unlockCycle: "",
                },
                addRules: {
                    "newCoinId": [{required: true, message: "新币挖矿关联id不能为空"}],
                    "poolCoin": [{required: true, message: "存入币挖不能为空"}],
                    "minAmount": [{required: true, message: "单笔最小存币数量不能为空"}],
                    "maxPointAmount": [{required: true, message: "最大小数位不能为空"}],
                    "priority": [{required: true, message: "优先级不能为空"}],
                    "unlockCycle": [{required: true, message: "解锁周期不能为空"}]
                },
                edit: false,
                loading: false
            }
        },
        filters: {},
        computed: {
            ...mapState("NewCoin", ["rewardConfigDialogVisible", "assetDetailDialogVisible", "incomeDetailDialogVisible", "poolId"])
        },
        methods: {
            ...mapMutations("NewCoin", ["setRewardConfigDialogVisible", "setAssetDetailDialogVisible", "setIncomeDetailDialogVisible", "setPoolId"]),
            getAllSupportCoin() {
                api.getAllSupportCoin().then(({data}) => {
                    this.coinTypes = data;
                });
            },
            getNewCoinPoolPage() {
                this.queryParams.newCoinId = this.currId;
                api.getNewCoinPoolPage(this.queryParams).then(({data}) => {
                    this.dataList = data.records;
                    this.total = data.total;
                });
            },
            addPoolDialog() {
                this.edit = false;
                this.dialogVisible = true;
                this.addData.newCoinId = this.currId;
            },
            updatePoolDialog(row) {
                this.addData = {
                    id: row.id,
                    newCoinId: row.newCoinId,
                    poolCoin: row.poolCoin,
                    minAmount: row.minAmount,
                    maxPointAmount: row.maxPointAmount,
                    priority: row.priority,
                    unlockCycle: row.unlockCycle,
                };
                this.edit = true;
                this.dialogVisible = true;
            },
            rewardConfigDialog(id) {
                this.setPoolId(id);
                this.setRewardConfigDialogVisible(true);
            },
            incomeDetailDialog(id) {
                this.setPoolId(id);
                this.setIncomeDetailDialogVisible(true);
            },
            assetDetailDialog(id) {
                this.setPoolId(id);
                this.setAssetDetailDialogVisible(true);
            },
            poolAddOrUpdate() {
                this.$refs["addForm"].validate(valid => {
                    if (valid) {
                        this.loading = true;
                        api.addOrUpdatePool(this.addData).then(({data}) => {
                            this.$message.success('操作成功!');
                            this.loading = false;
                            this.dialogVisible = false;
                            this.getNewCoinPoolPage();
                        });
                        setTimeout(() => {
                            this.loading = false;
                        }, 1000);
                    }
                });
            },
            deletePool(id) {
                this.$confirm('确认删除吗？', '提示', {
                    type: 'warning'
                }).then(() => {
                    api.deletePool({id: id}).then(() => {
                        this.$message.success('操作成功');
                        this.getNewCoinPoolPage();
                    });
                }).catch(() => {
                });
            },
            alterStopUsing(id, status) {
                this.$confirm(status ? '确认启动吗？' : '确认停用吗？', '提示', {
                    type: 'warning'
                }).then(() => {
                    api.stopUsingPool({id: id, stopUsing: status ? 'PUT' : 'LOADING'}).then(() => {
                        this.$message.success('操作成功');
                        this.getNewCoinPoolPage();
                    });
                }).catch(() => {
                });
            },
            alterPutStatus(id, status) {
                this.$confirm(status ? '确认上架吗？' : '确认下架吗？', '提示', {
                    type: 'warning'
                }).then(() => {
                    api.updatePoolState({id: id, put: status ? 'PUT' : 'DOWN'}).then(() => {
                        this.$message.success('操作成功');
                        this.getNewCoinPoolPage();
                    });
                }).catch(() => {
                });
            },
            unlockPool(id) {
                this.$confirm('确认进行一键解锁吗？', '提示', {
                    type: 'warning'
                }).then(() => {
                    api.unlockPool({id: id}).then(() => {
                        this.$message.success('操作成功');
                        this.getNewCoinPoolPage();
                    });
                }).catch(() => {
                });
            },
            handleSizeChange(val) {
                this.queryParams.size = val;
                this.getNewCoinPoolPage();
            },
            handleCurrentChange(val) {
                this.queryParams.page = val;
                this.getNewCoinPoolPage();
            },
            querySearch(queryString, cb) {
                var results = [];
                var coinList = this.coinTypes;
                results = queryString ? coinList.filter(this.createFilter(queryString)) : coinList;
                results = results.map((v, i, arr) => {
                    return {
                        value: v
                    }
                });
                // 调用 callback 返回建议列表的数据
                cb(results);
            },
            createFilter(queryString) {
                let tempData = this.coinTypes;
                return (tempData) => {
                    return (tempData.toLowerCase().indexOf(queryString.toLowerCase()) === 0);
                };
            },
            cleanSearchCoin() {
                this.addData.poolCoin = '';
            },
            clearData() {
                this.$refs["addForm"].resetFields();
                this.loading = false;
                this.addData = {
                    id: "",
                    newCoinId: "",
                    poolCoin: "",
                    minAmount: "",
                    maxPointAmount: "",
                    priority: "",
                    unlockCycle: "",
                };
                this.edit = false;
            },
            backPage() {
                this.$router.go(-1);
            },
        },
        created() {
            this.currId = this.$route.query.id;
            this.getAllSupportCoin();
            this.getNewCoinPoolPage();
        },
        destroyed() {
            this.setRewardConfigDialogVisible(false);
            this.setIncomeDetailDialogVisible(false);
            this.setAssetDetailDialogVisible(false);
        }
    };
</script>

<style lang="less" scoped>

</style>
